<ng-container [formGroup]="formGroup">
  <mat-form-field class="login-wrap__text">
    <mat-label>{{ 'pages.restaurantAccount.bostonPizzaEventsAPIChapterId' | translate }}</mat-label>
    <input matInput appFormInputTrim formControlName="chapterId">
    <mat-error *ngIf="formGroup.get('chapterId')?.errors && formGroup.get('chapterId')?.touched">
      {{ 'pages.restaurantAccount.maxLengthValidation' | translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="login-wrap__text">
    <mat-label>{{ 'pages.restaurantAccount.bostonPizzaEventsAPIChapterLocation' | translate }}</mat-label>
    <input matInput appFormInputTrim formControlName="chapterLocation">
    <mat-error *ngIf="formGroup.get('chapterLocation')?.errors && formGroup.get('chapterLocation')?.touched">
      {{ 'pages.restaurantAccount.maxLengthValidation' | translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="login-wrap__text">
    <mat-label>{{ 'pages.restaurantAccount.bostonPizzaEventsAPIChapterTitle' | translate }}</mat-label>
    <input matInput appFormInputTrim formControlName="chapterTitle">
    <mat-error *ngIf="formGroup.get('chapterTitle')?.errors && formGroup.get('chapterTitle')?.touched">
      {{ 'pages.restaurantAccount.maxLengthValidation' | translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="login-wrap__text">
    <mat-label>{{ 'pages.restaurantAccount.bostonPizzaEventsAPISlug' | translate }}</mat-label>
    <input matInput appFormInputTrim formControlName="slug">
    <mat-error *ngIf="formGroup.get('slug')?.errors && formGroup.get('slug')?.touched">
      {{ 'pages.restaurantAccount.maxLengthValidation' | translate }}
    </mat-error>
  </mat-form-field>
</ng-container>
